import { IDebugWinPresentationModeState } from '@GFTypes/GameStoreTypes/DebugWinPresentationModeState';

export const DEBUG_WIN_PRESENTATION_MODE_STATE_DEFAULTS: IDebugWinPresentationModeState = {
    available: false,
    active: false,
    nextWinPresentationRequested: false,
    ofAKindModifier: undefined
};
